import { z } from 'zod'

export const expenseTypeSchema = z.object({
  id: z.coerce.number().optional(),
  name: z.string().min(1, 'Expense type name is required').max(100, 'Name must be less than 100 characters'),
  description: z.string().optional().nullable(),
  active: z.boolean().default(true),
  business_id: z.string().uuid('Invalid business ID'),
  created_at: z.date().optional(),
  // Two-level hierarchy: null = top-level, number = child of that type.
  // '' (the "None" select option) is normalized to null. undefined stays undefined
  // so partial updates (e.g. toggling active) never clobber an existing parent.
  parent_id: z.preprocess(
    v => (v === '' ? null : v),
    z.coerce.number().positive('Invalid parent expense type').nullable().optional(),
  ),
})

export type ExpenseType = z.infer<typeof expenseTypeSchema>

// Schema for updating (all fields optional except id)
export const updateExpenseTypeSchema = expenseTypeSchema
  .omit({ business_id: true, created_at: true })
  .partial()
  .required({ id: true })
  .transform((data) => {
    // Remove undefined values to only update provided fields
    const cleaned: any = { id: data.id }
    if (data.name !== undefined) cleaned.name = data.name
    if (data.description !== undefined) cleaned.description = data.description
    if (data.active !== undefined) cleaned.active = data.active
    if (data.parent_id !== undefined) cleaned.parent_id = data.parent_id
    return cleaned
  })

// Schema for creating (no id required)
export const createExpenseTypeSchema = expenseTypeSchema.omit({ id: true, created_at: true })
